import { getCheckInDateRange } from '@hiptraveler/data-access/api';
import { cleanObject, clientVID } from '@hiptraveler/common';

export function getHotelInformationParam(): Record<string, string> {
  return cleanObject({
    vId: `${clientVID()}`,
    ...getCheckInDateRange()
  });
}
